import { Avatar, Box, Typography } from '@mui/material';

interface CompanyHeaderProps {
  logo?: string;
  companyName?: string;
  size?: number;
}

const CompanyHeader = ({
  logo,
  companyName = 'Company Name',
  size = 48,
}: CompanyHeaderProps) => {
  return (
    <Box display='flex' alignItems='center' gap={2}>
      {/* Logo Placeholder / Avatar */}
      <Avatar
        src={logo}
        alt={companyName}
        sx={{ width: size, height: size, bgcolor: 'grey.200' }}
      >
        {/* Fallback: first letter of company name */}
        {companyName.charAt(0).toUpperCase()}
      </Avatar>

      {/* Company Name */}
      <Typography variant='h6' fontWeight='bold' color='text.primary'>
        {companyName}
      </Typography>
    </Box>
  );
};

export default CompanyHeader;
